import { ReactElement, useEffect, useRef } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";
import ItemValue from "./itemValue";
import { IComponentProps } from "./types";
import Header from "./header";

const LRFComponent = ({ realtime, overviewData, updateOverview, firstTime }: IComponentProps): ReactElement => {
  const heatNumber = useRef<any>(null);
  const actualHeatNumber = realtime["MS.LRF.N2.ACTUAL_HEAT_NUMBER_LS"];

  useEffect(() => {
    if (actualHeatNumber && actualHeatNumber.Value !== heatNumber.current) {
      if (heatNumber.current !== null && !firstTime) {
        updateOverview("LRF");
      }

      heatNumber.current = actualHeatNumber.Value;
    }
  }, [actualHeatNumber]);

  return (
    <Card style={{ background: "rgba(0, 0, 0, .3)" }}>
      <CardHeader className="p-1" title="LRF" style={{ background: "rgba(82,99,108, 1)" }} />
      <CardContent className="p-0">
        <Header overviewData={overviewData} />

        <div className="display-grid gap-1 p-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>

          <div className="display-grid justify-content-start align-content-center">
            <strong>CURRENT</strong>
          </div>
          <ItemValue title="A" value={realtime["MS.LRF.PHASE_CURR_A"]?.Value} color="green"/>
          <ItemValue title="B" value={realtime["MS.LRF.PHASE_CURR_B"]?.Value} color="green"/>
          <ItemValue title="C" value={realtime["MS.LRF.PHASE_CURR_C"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>VOLTAGE</strong>
          </div>
          <ItemValue title="A" value={realtime["MS.LRF.PHASE_VOL_A"]?.Value} color="green"/>
          <ItemValue title="B" value={realtime["MS.LRF.PHASE_VOL_B"]?.Value} color="green"/>
          <ItemValue title="C" value={realtime["MS.LRF.PHASE_VOL_C"]?.Value} color="green"/>
        </div>
      </CardContent>
    </Card>
  );
};

export default LRFComponent;